<script setup lang="ts">
import EpTab from '~/components/tab/EpTab.vue'
import { routes } from '~/routes'

const tabList = [
  {
    label: 'Home',
    value: routes.getContentPage()
  },
  // {
  //   label: 'Notice',
  //   value: routes.getContentPage('notice')
  // },
  {
    label: 'Event',
    value: routes.getContentPage('event')
  },
  {
    label: 'Research',
    value: routes.getContentPage('research')
  },
  {
    label: 'Blog',
    value: routes.getContentPage('blog')
  },
]

const route = useRoute()
const router = useRouter()

const activeTabList = computed(() => {
  return tabList.map(tab => {
    return {
      ...tab,
      isActive: tab.value === route.path
    }
  })
})

const goPage = (path: string) => {
  router.push(path)
}
</script>

<template>
  <EpTab
    :tab-list="activeTabList"
    @click-tab="goPage"
    bold
  />
</template>

<style scoped lang="scss">

</style>